import { skipToken, useQuery } from '@tanstack/react-query'

import { CAR_QUERY_KEYS } from '@/entities/car/lib'

import { getMacarDetail } from '../request/carApis'

import type { IMacar } from '@/entities/car/model'

/**
 * 차량 상세(getMacar) 조회 훅
 * macarId가 없거나 enabled=false면 조회하지 않는다(호출자가 필요 시점을 제어)
 */
const useMacarDetailQuery = ({
  macarId,
  enabled = true,
}: {
  macarId?: number
  enabled?: boolean
}) => {
  return useQuery<IMacar>({
    queryKey: CAR_QUERY_KEYS.MACAR.detail(macarId),
    queryFn:
      enabled && macarId != null ? () => getMacarDetail(macarId) : skipToken,
    throwOnError: false,
  })
}

export default useMacarDetailQuery
